import { render, staticRenderFns } from "./Leaderboards.vue?vue&type=template&id=aadbc00c&scoped=true&"
import script from "./Leaderboards.vue?vue&type=script&lang=ts&"
export * from "./Leaderboards.vue?vue&type=script&lang=ts&"
import style0 from "./Leaderboards.vue?vue&type=style&index=0&id=aadbc00c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadbc00c",
  null
  
)

export default component.exports